import { createContext } from "react";

export const RealRaceTimeContext = createContext<number>(0);
